import { RootState } from 'lib/centralStore';
import dynamic from 'next/dynamic';
import { useSelector } from 'react-redux';
import { IppicaHeaderInfo } from '../../ippicaHeaderInfo';
import { IppicaScommesseAntepostRenderer } from '../../ippicaScommesseAntepostRenderer';

export const DynamicIppicaDetailsRendererAntepost = dynamic(() =>
  import('features/ippica/components/ippicaDetailsRenderer/ippicaDetailsRendererAntepost').then(
    (mod) => mod.IppicaDetailsRendererAntepost
  )
);
export const IppicaDetailsRendererAntepost = () => {
  const { isOpen } = useSelector((store: RootState) => store.carrello);

  return (
    <>
      <IppicaHeaderInfo hasMarginRight={!isOpen} />
      <IppicaScommesseAntepostRenderer />
    </>
  );
};
